import React from 'react';
import classNames from 'classnames';
import { Button } from '@agissc/ktag-map';

interface BasemapItemProps {
  previewImage: string;
  title: string;
  isActive: boolean;
  onSelect: () => void;
}
const BasemapItem = ({ previewImage, title, isActive, onSelect }: BasemapItemProps) => {
  return (
    <Button
      onClick={onSelect}
      additionalClassNames={classNames('basemap-selection__button', {
        'basemap-selection__button--active': isActive,
      })}
    >
      <figure className="basemap-selection__button-figure">
        <img
          src={previewImage}
          alt={title}
          title={title}
          className="basemap-selection__button-figure-img"
        />
      </figure>
    </Button>
  );
};

export default BasemapItem;
